"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ApiTokensController", {
    enumerable: true,
    get: function() {
        return ApiTokensController;
    }
});
const _common = require("@nestjs/common");
const _globalguard = require("~/guards/global/global.guard");
const _PagedResponse = require("~/helpers/PagedResponse");
const _apitokensservice = require("~/services/api-tokens.service");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _config = require("~/interface/config");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let ApiTokensController = class ApiTokensController {
    async apiTokenList(req) {
        return new _PagedResponse.PagedResponseImpl(await this.apiTokensService.apiTokenList({
            userId: req['user'].id,
            req
        }));
    }
    async apiTokenCreate(req, body) {
        return await this.apiTokensService.apiTokenCreate({
            tokenBody: body,
            userId: req['user'].id,
            req
        });
    }
    async apiTokenDelete(req, tokenId) {
        return await this.apiTokensService.apiTokenDelete({
            tokenId,
            user: req['user'],
            req
        });
    }
    constructor(apiTokensService){
        this.apiTokensService = apiTokensService;
    }
};
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/projects/:baseId/api-tokens',
        '/api/v2/meta/bases/:baseId/api-tokens'
    ]),
    (0, _extractidsmiddleware.Acl)('baseApiTokenList'),
    _ts_param(0, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], ApiTokensController.prototype, "apiTokenList", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/projects/:baseId/api-tokens',
        '/api/v2/meta/bases/:baseId/api-tokens'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('baseApiTokenCreate'),
    _ts_param(0, (0, _common.Req)()),
    _ts_param(1, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        void 0
    ]),
    _ts_metadata("design:returntype", Promise)
], ApiTokensController.prototype, "apiTokenCreate", null);
_ts_decorate([
    (0, _common.Delete)([
        '/api/v1/db/meta/projects/:baseId/api-tokens/:tokenId',
        '/api/v2/meta/bases/:baseId/api-tokens/:tokenId'
    ]),
    (0, _extractidsmiddleware.Acl)('baseApiTokenDelete'),
    _ts_param(0, (0, _common.Req)()),
    _ts_param(1, (0, _common.Param)('tokenId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], ApiTokensController.prototype, "apiTokenDelete", null);
ApiTokensController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _apitokensservice.ApiTokensService === "undefined" ? Object : _apitokensservice.ApiTokensService
    ])
], ApiTokensController);
